import React from "react"
import { Link } from "gatsby"
import { useLayoutContext } from "~layout/contexts/layout"
import usePage from "~common/hooks/usePage"
import { useDrawerContext, provideDrawerContext } from "~common/contexts/drawer"
import { Box } from "~common/components/Primitives"
import Brand from "~common/components/Brand"
import NavbarNav from "~common/components/NavbarNav"
import Icon from "~common/components/Icon"
import Drawer from "~common/components/Drawer"

const Header = provideDrawerContext(({ sx, ...rest }) => {
  const { headerRef, headerCollapse } = useLayoutContext()

  const { isDrawerOpen, handleDrawerOpen, handleDrawerClose } =
    useDrawerContext()

  const isIndex = usePage("/")

  return (
    <>
      <Box
        ref={headerRef}
        as="header"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 10,
          ...sx,
        }}
        {...rest}
      >
        <Box
          sx={{
            px: [4, 5],
            py: headerCollapse ? [3, 4] : [4, 5],
            transition: "all 300ms",
            bg:
              headerCollapse || isDrawerOpen || !isIndex
                ? "primary"
                : "#fefefe00",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Link to="/">
            <Brand />
          </Link>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <NavbarNav />
              <Icon
                sx={{
                  display: ["static", "static", "none"],
                  "&:hover": {
                    cursor: "pointer",
                    fill: "accent",
                  },
                }}
                variant="button"
                name={isDrawerOpen ? "close" : "menu"}
                onClick={isDrawerOpen ? handleDrawerClose : handleDrawerOpen}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Drawer />
    </>
  )
})

export default Header
